import React from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { Box, Flex, Icon, Text, FlexProps } from '@chakra-ui/react';

export const INDICATOR_EMPTY_COPY = {
  title: 'Sem dados no momento',
  description:
    'Não há informações para exibir com os filtros atuais. Tente ampliar o período ou verifique se existem registros para sua frota.',
} as const;

interface IndicatorEmptyNoticeProps extends FlexProps {
  title?: string;
  description?: string;
}

/** Faixa compacta — usada no rodapé do card, sem cobrir o gráfico. */
export const IndicatorEmptyNotice: React.FC<IndicatorEmptyNoticeProps> = ({
  title = INDICATOR_EMPTY_COPY.title,
  description = INDICATOR_EMPTY_COPY.description,
  ...rest
}) => (
  <Flex
    align="flex-start"
    gap={2}
    px={3}
    py={2.5}
    w="100%"
    borderRadius="md"
    bg="orange.50"
    border="1px solid"
    borderColor="orange.200"
    role="status"
    {...rest}
  >
    <Icon
      as={HiOutlineInformationCircle}
      boxSize={5}
      color="orange.500"
      flexShrink={0}
      mt="1px"
    />
    <Flex direction="column" align="flex-start" textAlign="left">
      <Text color="text.100" fontSize="sm" fontWeight={700} lineHeight="1.3">
        {title}
      </Text>
      <Text color="text.600" fontSize="xs" lineHeight="1.45" mt={0.5}>
        {description}
      </Text>
    </Flex>
  </Flex>
);

interface IndicatorEmptyContentProps {
  isEmpty: boolean;
  showEmptyState: boolean;
  children: React.ReactNode;
  emptyDescription?: string;
}

/** Gráfico ocupa o espaço; aviso fixado no rodapé da área do card. */
export const IndicatorEmptyContent: React.FC<IndicatorEmptyContentProps> = ({
  isEmpty,
  showEmptyState,
  children,
  emptyDescription,
}) => (
  <Flex direction="column" w="100%" flex={1} minH={0} align="stretch">
    <Flex flex={1} w="100%" minH={0} align="stretch">
      {children}
    </Flex>
    {isEmpty && showEmptyState && (
      <Box mt="auto" pt={3} w="100%" flexShrink={0}>
        <IndicatorEmptyNotice description={emptyDescription} />
      </Box>
    )}
  </Flex>
);
